/**
 * @generated SignedSource<<258306c4da5a4a478703ef6a8559ec10>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ACLFormFields_query$data = {
  readonly whoami: {
    readonly email: string | null | undefined;
    readonly name: string | null | undefined;
    readonly roleAssignmentPrincipal: any;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ACLPrincipalPicker_principals">;
  readonly " $fragmentType": "ACLFormFields_query";
};
export type ACLFormFields_query$key = {
  readonly " $data"?: ACLFormFields_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"ACLFormFields_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ACLFormFields_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ACLPrincipalPicker_principals"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrentUser",
      "kind": "LinkedField",
      "name": "whoami",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "roleAssignmentPrincipal",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "5dee81d1a63504bdfe5c554da627e89f";

export default node;
